module.exports = __webpack_public_path__ + "img/icon-c-text.caf19a4e.svg";